import { AgsBetBarComponent } from "ags/components/ags-bet-bar-component";
import { AgsHeaderComponent } from "ags/components/ags-header-component";
import { AgsPreloaderComponent } from "ags/components/ags-preloader-component";
import { AgsPromptComponent } from "ags/components/ags-prompt-component";
import { AgsSymbolFooterComponent } from "ags/components/ags-symbol-footer-component";
import { AgsForceTab } from "ags/debug/menu/tabs/ags-force-tab";
import { SpinRecordBuilder } from "ags/integration/builders/records/spin-record-builder";
import { AuthRequestBuilder } from "ags/integration/builders/requests/auth-request-builder";
import { SpinRequestBuilder } from "ags/integration/builders/requests/spin-request-builder";
import { AgsTrailStateResultBuilder } from "ags/integration/builders/results/firework-state-result-builder";
import { PretellResultBuilder } from "ags/integration/builders/results/pretell-result-builder";
import { ScatterResultBuilder } from "ags/integration/builders/results/scatter-result-builder";
import { SparkResultBuilder } from "ags/integration/builders/results/spark-result-builder";
import { agsSpinForcer } from "ags/integration/precan/ags-spin-forcer";
import { AgsSetup } from "ags/setup/ags-setup";
import { Components } from "appworks/components/components";
import { HTMLText } from "appworks/graphics/pixi/html-text";
import { builderManager } from "appworks/server/builders/builder-manager";
import { Services } from "appworks/services/services";
import { TranslationsService } from "appworks/services/translations/translations-service";
import { ThemeMatrixFactory } from "components/factories/theme-matrix-factory";
import { ThemeJackpotDisplayComponent } from "components/theme-jackpot-display-component";
import { gameLayers } from "game-layers";
import { ThemePickRecordBuilder } from "integration/records/theme-pick-record-builder";
import { ThemeRecoveryRecordBuilder } from "integration/records/theme-recovery-record-builder";
import { ThemeGridSizeResultBuilder } from "integration/results/theme-grid-size-result";
import { ThemeHarpoonResultBuilder } from "integration/results/theme-harpoon-result";
import { ThemeSoundSetup } from "setup/theme-sound-setup";
import { ThemeStateSetup } from "setup/theme-state-setup";
import { AlertComponent } from "slotworks/components/alert/alert-component";
import { GenericComponentFactory } from "slotworks/components/factories/generic-component-factory";
import { AnticipationSkipMode, SpinReelTransition } from "slotworks/components/matrix/reel/transition-behaviours/spin/spin-reel-transition";
import { DebugMenu } from "slotworks/debug/menu/debug-menu";
import { ThemeGameDefinitionSetup } from "./theme-game-definition-setup";
import { ThemeLayerSetup } from "./theme-layer-setup";
import { ThemeCelebrateWinComponent } from "components/theme-celebrate-win-component";
import { ThemeLineResultBuilder } from "integration/results/theme-line-result-builder";
import { ThemeAnimateWinsComponent } from "components/theme-animate-wins-component";
import { ThemeAuthRecordBuilder } from "integration/records/theme-auth-record-builder";
import { FadeTransition } from "appworks/transitions/fade-transition";
import { FreespinRequestBuilder } from "ags/integration/builders/requests/freespin-request-builder";
import { ThemeLoopWinsComponent } from "components/theme-loop-wins-component";
import { BigWinComponent } from "ags/components/big-win-component";
import { ThemeHtmlRulesComponent } from "components/theme-html-rules-component";

export class ThemeSetup extends AgsSetup {
    public setupComponents(): void {
        SpinReelTransition.anticipationSkipMode = AnticipationSkipMode.NEVER;

        Components.register(new GenericComponentFactory(ThemeHtmlRulesComponent));
        Components.register(new GenericComponentFactory(AgsBetBarComponent));
        Components.register(new GenericComponentFactory(ThemeAnimateWinsComponent, false));
        Components.register(new GenericComponentFactory(ThemeLoopWinsComponent));
        Components.register(new GenericComponentFactory(AgsHeaderComponent));
        Components.register(new GenericComponentFactory(ThemeCelebrateWinComponent));
	Components.register(new GenericComponentFactory(BigWinComponent));
        Components.register(new ThemeMatrixFactory());
        Components.register(new GenericComponentFactory(ThemeJackpotDisplayComponent));
        Components.register(new GenericComponentFactory(AgsSymbolFooterComponent, {
            symbolScale: 1,
            paddingX: 0.2,
            paddingY: -0.5,
            invalidSymbols: ["TT"]
        }));

        Components.register(new GenericComponentFactory(AlertComponent), 0);
        Components.register(new GenericComponentFactory(AgsPromptComponent, { usePromptLayerAsClickListener: true }), 0);
        Components.register(new GenericComponentFactory(AgsPreloaderComponent), 0);

        // To stop text wrapping on preloader, don't know where better to put this
        HTMLText.minFontSize = 2;
    }

    public setupComms(): void {
        super.setupComms();

        builderManager.addRequestBuilder(new AuthRequestBuilder());
        builderManager.addRequestBuilder(new SpinRequestBuilder());
        builderManager.addRequestBuilder(new FreespinRequestBuilder());

        builderManager.addRecordBuilder(new ThemeAuthRecordBuilder());
        builderManager.addRecordBuilder(new SpinRecordBuilder());
        builderManager.addRecordBuilder(new ThemeRecoveryRecordBuilder());
        builderManager.addRecordBuilder(new ThemePickRecordBuilder());

        builderManager.addResultBuilder(new ScatterResultBuilder());
        builderManager.addResultBuilder(new ThemeLineResultBuilder());
        builderManager.addResultBuilder(new SparkResultBuilder());
        builderManager.addResultBuilder(new PretellResultBuilder());
        builderManager.addResultBuilder(new AgsTrailStateResultBuilder());
        builderManager.addResultBuilder(new ThemeHarpoonResultBuilder());
        builderManager.addResultBuilder(new ThemeGridSizeResultBuilder());

        builderManager.addResultBuilder(new ThemeGridSizeResultBuilder());
    }

    public setupDebug(): void {
        super.setupDebug();
        this.setupSpinForces();
    }

    public setupGameDefinition(): void {
        ThemeGameDefinitionSetup();
    }

    public setupI18N(): void {
        super.setupI18N();

        const translations = Services.get(TranslationsService);
        translations.setAlias("pmt.pts", "press_screen");
        translations.setAlias("fot.fs", "free_spins_won");
        translations.setAlias("fot.ret", "x_more_freespins_awarded_footer");
        translations.setAlias("fs.wsu", "freespins_won_credits");
        /*gameLayers.Menus.onSceneEnter.add((sceneName: string) => {
            if (sceneName === "preloader") {
                const waysToWinText = gameLayers.Menus.getText("waystowin");
                const value: string = (16807).toLocaleString(gameiomModel.language);
                waysToWinText.text = translations.get("ways_to_win", { ways: value });
            }
        });*/

        HTMLText.setTagStyling("yellow", { fill: 0xfff409, stroke: 0xa44106, strokeThickness: 2 });
        HTMLText.setTagStyling("big", { fontScaleWidth: 1.2, fontScaleHeight: 1.2 });
        HTMLText.setTagStyling("big_spins", { fontScaleWidth: 1.2, fontScaleHeight: 1.2 });
        HTMLText.setTagStyling("boost", {
            fill: [0xfff97a, 0xfff409],
            fillGradientStops: [0.4, 0.9],
            fillGradientType: PIXI.TEXT_GRADIENT.LINEAR_VERTICAL,
            fontScaleWidth: 1.3,
            fontScaleHeight: 1.3
        });
    }

    public setupLayers(): void {
        super.setupLayers();
        ThemeLayerSetup();
    }

    public setupSound(): void {
        super.setupSound();
        ThemeSoundSetup();
    }

    public setupStates(): void {
        ThemeStateSetup();
    }
    public setupTransitions(): void {
        gameLayers.Prompts.setTransitions("freespinssummary", new FadeTransition(gameLayers.Prompts, 500));
        gameLayers.Prompts.setTransitions("freespinsretrigger", new FadeTransition(gameLayers.Prompts, 500));
        gameLayers.Prompts.setTransitions("freespinswin", new FadeTransition(gameLayers.Prompts, 500));
    }

    protected setupSpinForces() {
        const forces = new Map<string, string>([
                ["2 line win", String.raw`{"Outcomes": [{"ReelSetSelector": [0],"ReelStopSelection":[19,9,19,19]}]}`],
                ["3x Red 7s",  String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["H1","H1","H1","BL"],"Line":[1]}]}`],
                ["3x Blue 7s", String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["H2","H2","H2","BL"],"Line":[1]}]}`],
                ["3x Black 7s",String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["H3","H3","H3","BL"],"Line":[1]}]}`],
                ["3x Mixed 7s",String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["H1","H2","H3","BL"],"Line":[1]}]}`],
                ["4x Red 7s",  String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["H1","H1","H1","H1"],"Line":[1]}]}`],
                ["4x Blue 7s", String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["H2","H2","H2","H2"],"Line":[1]}]}`],
                ["4x Black 7s",String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["H3","H3","H3","H3"],"Line":[1]}]}`],
                ["4x Mixed 7s",String.raw`{"Outcomes":[{"ReelSetSelector":[1],"SymbolNameSelection":["H1","H2","H3","H1"],"Line":[1]}]}`],
                ["3x Red 7s 2X",  String.raw`{"Outcomes":[{"ReelSetSelector":[1],"SymbolNameSelection":["X2","H1","H1","BL"],"Line":[1]}]}`],
                ["3x Red 7s 3X",  String.raw`{"Outcomes":[{"ReelSetSelector":[1],"SymbolNameSelection":["H1","H1","X3","BL"],"Line":[1]}]}`],
                ["4x Red 7s 2X",  String.raw`{"Outcomes":[{"ReelSetSelector":[1],"SymbolNameSelection":["H1","H1","H1","X2"],"Line":[1]}]}`],
                ["4x Red 7s 3X",  String.raw`{"Outcomes":[{"ReelSetSelector":[1],"SymbolNameSelection":["H1","H1","X3","H1"],"Line":[1]}]}`],
                ["3x Red 7s 6X",  String.raw`{"Outcomes":[{"ReelSetSelector":[1],"SymbolNameSelection":["X2","H1","X3","BL"],"Line":[1]}]}`],
                ["4x Red 7s 6X",  String.raw`{"Outcomes":[{"ReelSetSelector":[1],"SymbolNameSelection":["H1","H1","X3","X2"],"Line":[1]}]}`],
                ["3x Red 7s 9X",  String.raw`{"Outcomes":[{"ReelSetSelector":[1],"SymbolNameSelection":["H1","X3","X3","BL"],"Line":[1]}]}`],
                ["4x Red 7s 9X",  String.raw`{"Outcomes":[{"ReelSetSelector":[1],"SymbolNameSelection":["H1","X3","X3","H1"],"Line":[1]}]}`],
                ["4x Red 7s 18X", String.raw`{"Outcomes":[{"ReelSetSelector":[1],"SymbolNameSelection":["H1","X3","X3","X2"],"Line":[1]}]}`],
                ["2x 2X3X", String.raw`{"Outcomes":[{"ReelSetSelector":[1],"SymbolNameSelection":["X2","X3","BL","BL"],"Line":[1]}]}`],
                ["3x 2X3X", String.raw`{"Outcomes":[{"ReelSetSelector":[1],"SymbolNameSelection":["X2","X3","X3","BL"],"Line":[1]}]}`],
                ["4x 2X3X", String.raw`{"Outcomes":[{"ReelSetSelector":[1],"SymbolNameSelection":["X2","X3","X3","X2"],"Line":[1]}]}`],
                ["bigwin",  String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["BL","BL","BL","BL"],"ReelStopSelection":[14,12,18,2]}]}`],
                ["hugewin", String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["BL","BL","BL","BL"],"ReelStopSelection":[8,18,18,6]}]}`],
                ["Retrigger Free spins during freespins",String.raw`{"Outcomes":[{"ReelSetSelector":[0],"ReelStopSelection":[1,1,1]}]}`],
                ["Free Spins 3 scatters in base",        String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["BO","H1","BL","H3"],"ReelStopSelection":[3,13,18,9]},{"ReelSetSelector":[0],"SymbolNameSelection":["BL","BL","BL","BL"],"ReelStopSelection":[8,0,12,20]},{"ReelSetSelector":[0],"SymbolNameSelection":["H3","BL","H1","BL"],"ReelStopSelection":[13,16,5,12]},{"ReelSetSelector":[0],"SymbolNameSelection":["BL","H3","H2","H2"],"ReelStopSelection":[14,9,21,13]},{"ReelSetSelector":[0],"SymbolNameSelection":["BL","BL","BL","H2"],"ReelStopSelection":[8,6,0,13]},{"ReelSetSelector":[0],"SymbolNameSelection":["BL","BL","BL","BL"],"ReelStopSelection":[14,14,0,0]},{"ReelSetSelector":[0],"SymbolNameSelection":["H2","BL","H1","H2"],"ReelStopSelection":[19,20,17,5]},{"ReelSetSelector":[1],"SymbolNameSelection":["BL","BL","H2","H2"],"ReelStopSelection":[8,4,21,13]},{"ReelSetSelector":[0],"SymbolNameSelection":["H1","BL","BL","H3"],"ReelStopSelection":[9,16,6,15]},{"ReelSetSelector":[1],"SymbolNameSelection":["X2","BL","BL","BL"],"ReelStopSelection":[11,16,6,8]},{"ReelSetSelector":[0],"SymbolNameSelection":["BL","H2","BL","BL"],"ReelStopSelection":[18,11,0,4]}]}`],
                ["test1", String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["BL","BL","BL","BL"],"ReelStopSelection":[9, 19, 7, 9]}]}`],
                ["test2", String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["BL","BL","BL","BL"],"ReelStopSelection":[9, 6, 7, 9]}]}`],
                ["test3", String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["BL","BL","BL","BL"],"ReelStopSelection":[9, 6, 6, 9]}]}`],
                ["test4", String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["BL","BL","BL","BL"],"ReelStopSelection":[9, 6, 21, 8]}]}`],
                ["test5", String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["BL","BL","BL","BL"],"ReelStopSelection":[0,7,11,0]}]}`],
                ["testcase4", String.raw`{"Outcomes":[{"ReelSetSelector":[0],"ReelStopSelection":[5,11,9,5]}]}`],
                ["testcase5", String.raw`{"Outcomes":[{"ReelSetSelector":[0],"ReelStopSelection":[3,17,9,5]}]}`],
                ["newantitest", String.raw`{"Outcomes":[{"ReelSetSelector":[0],"ReelStopSelection":[5,5,1,5]}]}`],
                ["no win fast", String.raw`{"Outcomes":[{"ReelSetSelector":[0],"SymbolNameSelection":["BL","BL","BL","BL"],"ReelStopSelection":[4, 7, 10, 5]}]}`],
                ["Crash Game", String.raw`crashgame`]
        ]);

        agsSpinForcer.setResults(forces);
        DebugMenu.add(new AgsForceTab("Spin Forces", agsSpinForcer));
    }
}
